<template>
  <section id="all-orders-listing" class="all-cases-view">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="10">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Order Id / Patient Name"
                    v-model="search_string"
                    @input="getAutoCompleteOrders()"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <!-- Web Version -->
      <div class="primary-content-view-new" v-loading="loading">
        <div class="listings listings__table listings__all-cases">
          <el-table
            :data="getValidationOrders.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column
              type="selection"
              width="40"
              class="selection-check"
            ></el-table-column>
            <el-table-column
              label="ORDER ID"
              prop="order_id"
              width="215"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div id="name-accession">
                  <span class="order-files ml-5">
                    <img
                      src="@/assets/images/orders-table-file.svg"
                      alt="icon"
                    />
                  </span>
                  <span
                    id="accession-id"
                    @click="goToOrdersView(scope.row._id)"
                    class="cursor ml-5"
                  >
                    {{ scope.row.order_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              width="130"
              prop="case_types"
              fixed="left"
              sortable="custom"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else class="case-type">
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="PATIENT NAME"
              prop="patient_info.first_name"
              width="160"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="convertToUppercase(getPatientNameByInfo(scope.row.patient_info))"
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Patient DOB"
              prop="date_of_birth"
              width="100"
            >
              <template #default="scope">
                {{ formatDate(scope.row.patient_info.date_of_birth) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="hospitals"
              label="ORDERING FACILITIES"
              min-width="200"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'"
                >
                  <span class="text-center ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="physican" label="physician" min-width="150">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes('Dr')
                        ? scope.row.ordering_physician.name
                        : 'Dr ' + scope.row.ordering_physician.name
                      : '--'
                  "
                >
                  <span class="ordering_physician-value">{{
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes("Dr")
                        ? scope.row.ordering_physician.name
                        : "Dr " + scope.row.ordering_physician.name
                      : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              width="130"
              prop="created_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              width="140"
              prop="status"
              sortable="custom"
            >
              <template #default="scope">
                <div class="column-status" v-if="scope.row.status">
                  <span
                    class="el-dropdown-link"
                    v-if="scope.row.status == 'COMPLETE'"
                  >
                    <el-tag :type="getStatusType(scope.row.status)"
                      >FINALIZED</el-tag
                    >
                  </span>
                  <span class="el-dropdown-link" v-else>
                    <el-tag :type="getStatusType(scope.row.status)">{{
                      scope.row.status
                    }}</el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="accession_id"
              label="ACCESSION ID"
              width="285"
              sortable="custom"
            >
              <template #default="scope">
                <div
                  class="name-accession cursor"
                  v-if="
                    scope.row.accession_data && scope.row.accession_data.length
                  "
                >
                  <span
                    id="accession-id-blue"
                    class="order-accession"
                    v-for="(acccession, index) in scope.row.accession_data"
                    :key="index"
                    @click="goToCaseView(acccession.case_id)"
                  >
                    {{ acccession.accession_id }}
                  </span>
                </div>
                <div
                  class="name-accession cursor"
                  @click="goToCaseView(scope.row.case_id)"
                  v-else-if="scope.row.case_id"
                >
                  <span id="accession-id-blue" class="order-accession">
                    {{ scope.row.accession_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              width="90"
              fixed="right"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToOrdersView(scope.row._id)">
                    <el-button class="view-button" title="View Order">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout="prev, pager, next, jumper, sizes, total"
            :total="getValidationOrders.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <ResonForValidation
      v-if="takeValidationReasonDialog"
      v-on:close="takeValidationReasonDialog = false"
      v-on:reasonSubmit="moveToValidation"
      title="Reason for Restore"
    ></ResonForValidation>
  </section>
</template>
  
  <script>
import { defineAsyncComponent } from "vue";

import { mapGetters } from "vuex";
import moment from "moment";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const ResonForValidation = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
export default {
  name: "",
  mixins: [FilterHelper, UserPermissionsHelper, caseDataHelper],
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  components: {
    ResonForValidation,
  },
  data() {
    return {
      page: 1,
      pageSize: 25,
      caseType: "",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      loading: false,
      search_string: "",
      orderBy: "",
      orderType: "",
      requestValidationOrder: "",
      takeValidationReasonDialog: false,
    };
  },
  computed: {
    isFacilityUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "ACCOUNT_MANAGER"
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else {
          return "";
        }
      };
    },

    ...mapGetters("orders", [
      "getValidationOrders",
      "getCaseDeleteStatus",
      "getCaseDeleteError",
      "getUpdateValidationStatus",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
  },
  async mounted() {
    this.setQueryParamsData();
    await this.fetchAllValidationOrders();
  },
  methods: {
    async moveToValidations(validation) {
      this.requestValidationOrder = validation;
      this.takeValidationReasonDialog = true;
    },
    async moveToValidation(reason) {
      try {
        this.loading = true;
        let params = {
          id: this.requestValidationOrder,
          status: false,
          validation_reason: reason,
        };
        await this.$store.dispatch("orders/changeCaseValidationStatus", params);
        if (this.getUpdateValidationStatus) {
          successNotification(
            "Validation labsquire Order restored to labsquire orders"
          );
          await this.fetchAllValidationOrders();
        } else {
          errorNotification("Error while restoring validation labsquire order");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedOrderPage
        ? parseInt(this.$route.query.selectedOrderPage)
        : 1;
      this.pageSize = this.$route.query.selectedOrderPageSize
        ? parseInt(this.$route.query.selectedOrderPageSize)
        : 25;
      if (this.$route.query.selectedOrderString) {
        this.search_string = this.$route.query.selectedOrderString;
      }
      if (this.$route.query.selectedOrderOrderBy) {
        this.orderBy = this.$route.query.selectedOrderOrderBy;
      }
      if (this.$route.query.selectedOrderOrderType) {
        this.orderType = this.$route.query.selectedOrderOrderType;
      }
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
        is_validation_purpose: true,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      params.status = this.selectedStatuses;
      if(this.isGowthamUser){
        params.is_old = true
      }
      return params;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedOrderPage: params.page,
        selectedOrderString: params.search_string,
        selectedOrderPageSize: params.limit,
        selectedOrderOrderBy: params.order_by,
        selectedOrderOrderType: params.order_type,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllValidationOrders();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllValidationOrders();
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllValidationOrders();
    },
    getAutoCompleteOrders() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllValidationOrders();
      }, 600);
    },
    async fetchAllValidationOrders() {
      try {
        let params = this.prepareParams();
        this.loading = true;
        await this.$store.dispatch("orders/fetchValidationOrders", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    goToOrdersView(orderId) {
      this.$router.push({
        name: "Order-Information",
        params: { order_id: orderId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
  },
};
</script>
  
  <style lang="scss">
#all-orders-listing {
  .image-fluid {
    width: 100%;
  }
  .order-files {
    img {
      position: relative;
      top: 3px;
      right: 4px;
    }
  }
  .listings__table {
    .name-accession {
      display: inline-block;
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    #accession-id {
      color: #eb5757;
      cursor: pointer;
    }
    #patient-name {
      overflow: hidden;
      margin-left: 7px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
  